import { render } from "./ShiftDetailsMemberModal.vue?vue&type=template&id=5606cb8c&scoped=true&ts=true"
import script from "./ShiftDetailsMemberModal.vue?vue&type=script&lang=ts"
export * from "./ShiftDetailsMemberModal.vue?vue&type=script&lang=ts"

import "./ShiftDetailsMemberModal.vue?vue&type=style&index=0&id=5606cb8c&scoped=true&lang=scss"
import "./ShiftDetailsMemberModal.vue?vue&type=style&index=1&id=5606cb8c&lang=scss"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5606cb8c"]])

export default __exports__